export interface RecentSearch {
  cityName: string;
  timestamp: number;
}
const RECENT_SEARCHES_KEY = "recent_city_searches";
const MAX_RECENT_SEARCHES = 5;

export const getRecentSearches = (): string[] => {
  if (typeof window === "undefined") return [];

  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!stored) return [];

    const searches: RecentSearch[] = JSON.parse(stored);
    // Sort by timestamp (most recent first) and return only city names
    return searches
      .sort((a, b) => b.timestamp - a.timestamp)
      .map((search) => search.cityName)
      .slice(0, MAX_RECENT_SEARCHES);
  } catch (error) {
    console.error("Error reading recent searches from localStorage:", error);
    return [];
  }
};

export const saveRecentSearch = (cityName: string): void => {
  if (typeof window === "undefined") return;

  try {
    const existing = getRecentSearches();

    // Remove if already exists to avoid duplicates
    const filtered = existing.filter((search) => search !== cityName);

    // Create new search entry
    const newSearch: RecentSearch = {
      cityName,
      timestamp: Date.now(),
    };

    // Get all stored searches
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    let allSearches: RecentSearch[] = [];

    if (stored) {
      allSearches = JSON.parse(stored);
      // Remove existing entry if it exists
      allSearches = allSearches.filter(
        (search) => search.cityName !== cityName
      );
    }

    // Add new search at the beginning
    allSearches.unshift(newSearch);

    // Keep only the most recent searches
    allSearches = allSearches.slice(0, MAX_RECENT_SEARCHES);

    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(allSearches));
  } catch (error) {
    console.error("Error saving recent search to localStorage:", error);
  }
};

export const clearRecentSearches = (): void => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch (error) {
    console.error("Error clearing recent searches from localStorage:", error);
  }
};
